module.exports = __webpack_public_path__ + "img/it.eff1ff8a.svg";